import React from 'react';
import { Field, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Toggler } from '@components';
import {
  RetornoContribuicaoInitialValues,
  RetornoContribuicaoSchema,
} from '@schemas';
import { enviarRequerimentoFormulario } from '../../../../store/requerimentos/thunks';

export const SuspensaoTaesa = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const envioLoading = useSelector(
    (state) => state.requerimentos.envio.loading
  );

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <Formik
          validateOnMount
          initialValues={RetornoContribuicaoInitialValues}
          validationSchema={RetornoContribuicaoSchema}
          onSubmit={(values) => {
            dispatch(
              enviarRequerimentoFormulario({
                campos: values,
                formulario: reference,
              })
            )
              .unwrap()
              .then(() => {
                navigate('/requerimentos/andamento');
              });
          }}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <p className="mb-4">
                Venho, por meio deste, requerer a suspensão, por prazo
                indeterminado, das minhas contribuições para o Plano Taesa de
                Benefícios Previdenciários (Taesaprev) da Fundação Forluminas de
                Seguridade Social – FORLUZ, de acordo com o Regulamento do
                Plano.
              </p>
              <div className="row">
                <Field
                  className="mb-3"
                  name="declaracao"
                  component={Toggler}
                  label="Por oportuno, declaro estar ciente de que continuo obrigado a recolher à FORLUZ as contribuições destinadas à cobertura das despesas de natureza administrativa, que serão descontadas nos termos do Regulamento."
                />
              </div>

              <hr className="mt-32 mt-xs-0 mb-32" />

              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid || envioLoading}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
